<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="page_viii"></a>In loving remembrance of my mother, Esther Pierina Paganelli Nannini Biagini And my dear friend, Captain Harry E. Watson</p>
<div class="img_container">
<img alt="Image" src="images/pviii_01.jpg"/>
</div>
<p class="ded1">A special thank-you to my editor, Susanne C. Johnson, M.A.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Dedication.vue?588d162c